import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnMessage } from 'src/app/models/return-message';
import { ResponseRegions } from 'src/app/models/shared/response-regions';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  private apis = {
    getRegions: 'zmp_region/Index/'
  };

  constructor(
    private http: HttpClient
  ) { }

  getRegions(): Observable<ReturnMessage<ResponseRegions>> {
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions);
  }

  getRegionsByRecommendationId(recommendationId: number): Observable<ReturnMessage<ResponseRegions>> {
    const options = {
      params: new HttpParams()
        .set('offerType', 'Recommendation')
        .set('offerId', recommendationId)
    };
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions, options);
  }

  getRegionsByQuoteId(quoteId: number): Observable<ReturnMessage<ResponseRegions>> {
    const options = {
      params: new HttpParams()
        .set('offerType', 'Quote')
        .set('offerId', quoteId)
    };
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions, options);
  }

  getRegionsWithoutNoneOption(): Observable<ReturnMessage<ResponseRegions>> {
    const options = {
      params: new HttpParams()
        .set('includeNoneOption', false)
    };
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions, options);
  }
}
